var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavbarRightVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 42,
    viewBox: "0 0 15 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.16644 6.00847C6.85112 4.7046 6.8923 2.95477 6.98766 1.67992C7.05478 0.783824 6.15269 0.000148773 4.99863 0.000148773H0.268136L0.268136 42H4.99863C6.15269 42 7.05478 41.2164 6.98766 40.3203C6.8923 39.0454 6.85112 37.2956 7.16644 35.9917C7.40192 35.0179 7.57029 34.47 8.01791 33.5417C8.80158 31.916 10.7748 31.4246 10.8847 29.6918C10.9732 28.2986 9.40426 26.3084 9.40426 26.3084C9.40426 26.3084 11.3773 26.0311 12.1749 25.3167C13.1207 24.4696 12.2565 23.4367 13.0274 22.4584C13.5329 21.8171 14.7324 21.0584 14.7324 21.0584C14.7324 21.0584 13.528 20.2051 13.0274 19.5126C12.3466 18.5707 13.0253 17.657 12.1749 16.8292C11.3948 16.07 9.40426 15.6918 9.40426 15.6918C9.40426 15.6918 10.9732 13.7016 10.8847 12.3085C10.7748 10.5756 8.80158 10.0841 8.01791 8.45843C7.57029 7.53015 7.40192 6.98227 7.16644 6.00847Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbarRightVector);
export default __webpack_public_path__ + "static/media/navbar_right_vector.e5f14c43673e0cfc634739a4a78db7be.svg";
export { ForwardRef as ReactComponent };